import React, { useEffect, useLayoutEffect, useRef } from 'react';

import MessageItem from './MessageItem';

function claveDia(iso) {
  const fecha = new Date(iso);
  return Number.isNaN(fecha.getTime()) ? '' : fecha.toDateString();
}

function etiquetaDia(iso) {
  const fecha = new Date(iso);
  if (Number.isNaN(fecha.getTime())) return '';
  const hoy = new Date();
  const ayer = new Date(hoy);
  ayer.setDate(hoy.getDate() - 1);
  if (fecha.toDateString() === hoy.toDateString()) return 'Hoy';
  if (fecha.toDateString() === ayer.toDateString()) return 'Ayer';
  return fecha.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
}

const UMBRAL_FONDO_PX = 120;

/**
 * Lista con scroll inverso: pega abajo al entrar y cuando llegan mensajes si ya
 * estabas al fondo; el scroll-top dispara la carga de mensajes antiguos
 * (paginación por before_seq, nunca offset).
 */
export default function MessageList({
  messages,
  myUserId,
  onEditar,
  onBorrar,
  onFlag,
  onCargarAntiguos,
  hayMas,
  cargandoAntiguos,
  onVerVideo,
}) {
  const contRef = useRef(null);
  const pegadoAlFondo = useRef(true);
  const ultimoSeq = useRef(0);

  const scrollAlFondo = () => {
    const el = contRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  };

  // Al montar y cuando llega algo nuevo estando al fondo: seguir al fondo.
  useLayoutEffect(() => {
    const maxSeq = messages.length ? messages[messages.length - 1].seq : 0;
    const hayNuevo = maxSeq > ultimoSeq.current;
    ultimoSeq.current = maxSeq;
    if (pegadoAlFondo.current && hayNuevo) scrollAlFondo();
  }, [messages]);

  useEffect(() => {
    scrollAlFondo();
  }, []);

  const onScroll = () => {
    const el = contRef.current;
    if (!el) return;
    pegadoAlFondo.current = el.scrollHeight - el.scrollTop - el.clientHeight < UMBRAL_FONDO_PX;
    if (el.scrollTop < 40 && hayMas && !cargandoAntiguos) {
      const alturaAntes = el.scrollHeight;
      Promise.resolve(onCargarAntiguos?.()).then(() => {
        // Mantener la vista donde estaba: compensar la altura insertada arriba.
        requestAnimationFrame(() => {
          const elAhora = contRef.current;
          if (elAhora) elAhora.scrollTop += elAhora.scrollHeight - alturaAntes;
        });
      });
    }
  };

  let diaAnterior = '';

  return (
    <div ref={contRef} onScroll={onScroll} className="min-h-0 flex-1 overflow-y-auto py-2">
      {cargandoAntiguos ? (
        <p className="py-2 text-center text-xs text-gray-400">Cargando mensajes anteriores…</p>
      ) : null}
      {messages.map((msg) => {
        const dia = claveDia(msg.created_at);
        const separador = dia && dia !== diaAnterior;
        diaAnterior = dia || diaAnterior;
        return (
          <React.Fragment key={msg.id}>
            {separador && (
              <div className="my-2 flex items-center gap-3 px-4">
                <span className="h-px flex-1 bg-gray-200" />
                <span className="text-[11px] font-medium text-gray-400">{etiquetaDia(msg.created_at)}</span>
                <span className="h-px flex-1 bg-gray-200" />
              </div>
            )}
            <MessageItem
              msg={msg}
              isOwn={Boolean(myUserId && msg.author_id && String(msg.author_id) === String(myUserId))}
              onEditar={onEditar}
              onBorrar={onBorrar}
              onFlag={onFlag}
            />
          </React.Fragment>
        );
      })}
      {messages.length === 0 && (
        <div className="px-4 py-8 text-center">
          <p className="text-sm text-gray-400">Aún no hay mensajes. Escribe el primero.</p>
          {onVerVideo ? (
            <button
              type="button"
              onClick={onVerVideo}
              className="mt-3 text-sm font-medium text-[#FF5400] hover:underline"
            >
              Ver cómo funciona Smack (51 s)
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
}
